import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.idcFunctions.entities.category.attributes.isSponsored',
    'resource:data.dimensions.idcFunctions.entities.category.attributes.legacy.position',
    'resource:data.dimensions.idcFunctions.entities.category.attributes.type',
    'resource:data.dimensions.idcFunctions.entities.category.records.buildingDepreciation',
    'resource:data.dimensions.idcFunctions.entities.category.records.collegeAdministration',
    'resource:data.dimensions.idcFunctions.entities.category.records.departmentAdministration',
    'resource:data.dimensions.idcFunctions.entities.category.records.equipmentDepreciation',
    'resource:data.dimensions.idcFunctions.entities.category.records.generalAdministration',
    'resource:data.dimensions.idcFunctions.entities.category.records.instruction',
    'resource:data.dimensions.idcFunctions.entities.category.records.interest',
    'resource:data.dimensions.idcFunctions.entities.category.records.library',
    'resource:data.dimensions.idcFunctions.entities.category.records.operationsAndMaintenance',
    'resource:data.dimensions.idcFunctions.entities.category.records.organizedResearch',
    'resource:data.dimensions.idcFunctions.entities.category.records.otherInstitutionalActivities',
    'resource:data.dimensions.idcFunctions.entities.category.records.otherSponsoredActivities',
    'resource:data.dimensions.idcFunctions.entities.category.records.sponsoredProjectAdministration',
    'resource:data.dimensions.idcFunctions.entities.category.records.studentAdministrativeServices',
    'resource:data.dimensions.idcFunctions.entities.category',
    'resource:data.dimensions.idcFunctions.entities.subcategory.attributes.isUtility',
    'resource:data.dimensions.idcFunctions.entities.subcategory.attributes.legacy.position',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.equipBuilding',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.equipCampus',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.equipDepartmental',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.equipRoom',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.gaAcademic',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.gaUniversityWide',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.omDepartmental',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.omEnvironmentHealthAndSafety',
    'resource:data.dimensions.idcFunctions.entities.subcategory.records.omUniversityWide',
    'resource:data.dimensions.idcFunctions.entities.subcategory',
    'resource:data.dimensions.idcFunctions',
    'resource:data.enums.idcFunctionType',
    'resource:data.enums.idcFunctionType.entries.administration',
    'resource:data.enums.idcFunctionType.entries.direct',
    'resource:data.enums.idcFunctionType.entries.facilities',
    // TODO: use this instead of the legacy positions on category & subcategory
    // 'data.dimensions.idcFunctions.attributes.position',
  ],
  description: 'Contains standard IDC function categories and subcategories',
  name: 'IDC Data - Functions',
} as const satisfies core.quiver.Package
